<template>
  <transition name="toast-fade">
    <div v-if="show" class="toast-wrapper" :class="[`toast--${type}`]">
      <div class="toast-content">
        <font-awesome-icon :icon="icon" class="toast-icon" />
        <span class="toast-message">{{ message }}</span>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { 
  faCheckCircle, 
  faExclamationCircle, 
  faInfoCircle 
} from '@fortawesome/free-solid-svg-icons'

const store = useStore()

const show = computed(() => store.state.toastShow)
const message = computed(() => store.state.toastMsg)
const type = computed(() => store.state.toastType)

const icon = computed(() => {
  switch (type.value) {
    case 'error': return faExclamationCircle
    case 'info': return faInfoCircle
    default: return faCheckCircle
  }
})
</script>

<style scoped>
.toast-wrapper {
  position: fixed;
  bottom: 120px; /* Above bottom navigation if any */
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  min-width: 200px;
  max-width: 90vw;
  padding: 12px 20px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

[data-theme="dark"] .toast-wrapper {
  background: rgba(30, 31, 33, 0.9);
  border-color: rgba(255, 255, 255, 0.05);
}

.toast-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.toast-icon {
  font-size: 18px;
}

.toast-message {
  font-size: 14px;
  font-weight: 600;
  color: #1e1f21;
}

[data-theme="dark"] .toast-message {
  color: #ffffff;
}

/* Types */
.toast--success .toast-icon { color: #3182f6; }
.toast--error .toast-icon { color: #ff4d4f; }
.toast--info .toast-icon { color: #8b95a1; }

/* Animation */
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, 20px);
}
</style>
